import Navbar from "../components/Navbar/Navbar";
import Hero from "../components/Hero/Hero";
function Teach() {
  return (
    <>
      <Navbar />
      <Hero
        cName="hero-mid"
        heroImg="https://images.unsplash.com/photo-1551836022-4c4c79ecde51?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
        title="Work with us"
        btnClass="hide"
      />
    </>
  );
}

export default Teach;
